<div class="modal-container">
  <div class="modal-header no-print">
    <h2 mat-dialog-title>
      <mat-icon>print</mat-icon>
      <span>Imprimir - {{ data.tituloAba }}</span>
    </h2>
    <button mat-icon-button (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content-body modal-print-container">
    @if (isLoading) {
    <div class="loading-container no-print">
      <app-loading-box width="100%" height="300px"></app-loading-box>
    </div>
    }

    @if (!isLoading && temDados) {
    <div class="print-title">
      <h2>{{ data.tituloAba }}</h2>
      @if (data.descricaoProduto) {
      <p>{{ data.descricaoProduto }}</p>
      }
    </div>

    @if (data.abaAtiva === 'movimentos') {
    <div class="table-responsive">
      <table mat-table [dataSource]="movimentos">
        <ng-container matColumnDef="dataHora">
          <th mat-header-cell *matHeaderCellDef>Data/Hora</th>
          <td mat-cell *matCellDef="let row">{{ row.datetimeMovimentacao | date: 'dd/MM/yyyy HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="operacao">
          <th mat-header-cell *matHeaderCellDef>Operação</th>
          <td mat-cell *matCellDef="let row">{{ row.descricaoOperacao }}</td>
        </ng-container>

        <ng-container matColumnDef="clienteFornecedor">
          <th mat-header-cell *matHeaderCellDef>Cliente/Fornecedor</th>
          <td mat-cell *matCellDef="let row">{{ row.clienteFornecedor || row.descricaoOrigem || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="unidade">
          <th mat-header-cell *matHeaderCellDef>Unidade</th>
          <td mat-cell *matCellDef="let row">{{ row.unidade || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="valorUnitario">
          <th mat-header-cell *matHeaderCellDef class="text-end">Valor unitário</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.valorUnitario | abnt:'preco' }}</td>
        </ng-container>

        <ng-container matColumnDef="custoMedio">
          <th mat-header-cell *matHeaderCellDef class="text-end">Custo médio</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.custoMedio | abnt:'preco' }}</td>
        </ng-container>

        <ng-container matColumnDef="reservado">
          <th mat-header-cell *matHeaderCellDef class="text-end">Reservado</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.saldoReservado | abnt:'quantidade' }}</td>
        </ng-container>

        <ng-container matColumnDef="movimentado">
          <th mat-header-cell *matHeaderCellDef class="text-end">Movimentado</th>
          <td mat-cell *matCellDef="let row" class="text-end">
            {{ row.movimentado > 0 ? '+' : '' }}{{ row.movimentado | abnt:'quantidade' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="disponivel">
          <th mat-header-cell *matHeaderCellDef class="text-end">Disponível</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.disponivel | abnt:'quantidade' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsMovimentos"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsMovimentos"></tr>
      </table>
    </div>
    }

    @if (data.abaAtiva === 'reservas') {
    <div class="table-responsive">
      <table mat-table [dataSource]="reservas">
        <ng-container matColumnDef="dataHora">
          <th mat-header-cell *matHeaderCellDef>Data/Hora</th>
          <td mat-cell *matCellDef="let row">{{ row.dataHora | date: 'dd/MM/yyyy HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="quantidade">
          <th mat-header-cell *matHeaderCellDef class="text-end">Quantidade</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.quantidade | abnt:'quantidade' }}</td>
        </ng-container>

        <ng-container matColumnDef="origem">
          <th mat-header-cell *matHeaderCellDef>Origem</th>
          <td mat-cell *matCellDef="let row">{{ row.descricaoOrigem || '-' }} {{ row.numeroDocumentoOrigem || '' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsReservas"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsReservas"></tr>
      </table>
    </div>
    }

    @if (data.abaAtiva === 'lotes') {
    <div class="table-responsive">
      <table mat-table [dataSource]="lotes">
        <ng-container matColumnDef="dataValidade">
          <th mat-header-cell *matHeaderCellDef>Data validade</th>
          <td mat-cell *matCellDef="let row">{{ row.dataValidade | date: 'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="numeroLote">
          <th mat-header-cell *matHeaderCellDef>Número do lote</th>
          <td mat-cell *matCellDef="let row">{{ row.numeroLote }}</td>
        </ng-container>

        <ng-container matColumnDef="reservado">
          <th mat-header-cell *matHeaderCellDef class="text-end">Reservado</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.saldoReservado | abnt:'quantidade' }}</td>
        </ng-container>

        <ng-container matColumnDef="disponivel">
          <th mat-header-cell *matHeaderCellDef class="text-end">Disponível</th>
          <td mat-cell *matCellDef="let row" class="text-end">{{ row.saldoDisponivel | abnt:'quantidade' }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">{{ textoStatusLote(row.statusBadge) }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsLotes"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsLotes"></tr>
      </table>
    </div>
    }

    @if (data.abaAtiva === 'series') {
    <div class="table-responsive">
      <table mat-table [dataSource]="series">
        <ng-container matColumnDef="numeroSerie">
          <th mat-header-cell *matHeaderCellDef>Número de série</th>
          <td mat-cell *matCellDef="let row">{{ row.numeroSerie }}</td>
        </ng-container>

        <ng-container matColumnDef="dataEntrada">
          <th mat-header-cell *matHeaderCellDef>Data entrada</th>
          <td mat-cell *matCellDef="let row">{{ row.dataEntrada | date: 'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">{{ textoStatusSerie(row.status) }}</td>
        </ng-container>

        <ng-container matColumnDef="pedido">
          <th mat-header-cell *matHeaderCellDef>Pedido vinculado</th>
          <td mat-cell *matCellDef="let row">{{ row.numeroPedidoVinculado || '-' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsSeries"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsSeries"></tr>
      </table>
    </div>
    }
    }

    @if (!isLoading && !temDados) {
    <div class="text-center p-4">
      <p>Nenhum registro encontrado para os filtros selecionados.</p>
    </div>
    }
  </div>

  <div class="modal-footer no-print">
    <button mat-stroked-button class="btn-secondary" (click)="fechar()">Cancelar</button>
    @if (!isLoading && temDados) {
    <button mat-flat-button class="btn-primary" (click)="imprimir()">
      <mat-icon>print</mat-icon>
      Imprimir
    </button>
    }
  </div>
</div>